/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeListMinecraftDropConfigDto,
  ApiEnvelopeMinecraftConfigOperationResultDto,
  ApiEnvelopeMinecraftDropConfigDto,
  CreateMinecraftDropConfigRequest,
  UpdateMinecraftDropConfigRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type minecraftConfigGetAllDropConfigsResponse200 = {
  data: ApiEnvelopeListMinecraftDropConfigDto
  status: 200
}

export type minecraftConfigGetAllDropConfigsResponse400 = {
  data: ApiEnvelopeListMinecraftDropConfigDto
  status: 400
}

export type minecraftConfigGetAllDropConfigsResponseSuccess = (minecraftConfigGetAllDropConfigsResponse200) & {
  headers: Headers;
};
export type minecraftConfigGetAllDropConfigsResponseError = (minecraftConfigGetAllDropConfigsResponse400) & {
  headers: Headers;
};

export type minecraftConfigGetAllDropConfigsResponse = (minecraftConfigGetAllDropConfigsResponseSuccess | minecraftConfigGetAllDropConfigsResponseError)

export const getMinecraftConfigGetAllDropConfigsUrl = () => {




  return `/api/MinecraftConfig/All`
}

export const useMinecraftConfigGetAllDropConfigsHook = (): ( options?: RequestInit) => Promise<minecraftConfigGetAllDropConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getMinecraftConfigGetAllDropConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type minecraftConfigGetDropConfigResponse200 = {
  data: ApiEnvelopeMinecraftDropConfigDto
  status: 200
}

export type minecraftConfigGetDropConfigResponse400 = {
  data: ApiEnvelopeMinecraftDropConfigDto
  status: 400
}

export type minecraftConfigGetDropConfigResponseSuccess = (minecraftConfigGetDropConfigResponse200) & {
  headers: Headers;
};
export type minecraftConfigGetDropConfigResponseError = (minecraftConfigGetDropConfigResponse400) & {
  headers: Headers;
};

export type minecraftConfigGetDropConfigResponse = (minecraftConfigGetDropConfigResponseSuccess | minecraftConfigGetDropConfigResponseError)

export const getMinecraftConfigGetDropConfigUrl = (dropConfigId: string,) => {




  return `/api/MinecraftConfig/${dropConfigId}`
}

export const useMinecraftConfigGetDropConfigHook = (): (dropConfigId: string, options?: RequestInit) => Promise<minecraftConfigGetDropConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (dropConfigId: string, options?: RequestInit) => {

        return customFetcher(getMinecraftConfigGetDropConfigUrl(dropConfigId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type minecraftConfigDeleteDropConfigResponse200 = {
  data: ApiEnvelopeMinecraftConfigOperationResultDto
  status: 200
}

export type minecraftConfigDeleteDropConfigResponse400 = {
  data: ApiEnvelopeMinecraftConfigOperationResultDto
  status: 400
}

export type minecraftConfigDeleteDropConfigResponseSuccess = (minecraftConfigDeleteDropConfigResponse200) & {
  headers: Headers;
};
export type minecraftConfigDeleteDropConfigResponseError = (minecraftConfigDeleteDropConfigResponse400) & {
  headers: Headers;
};

export type minecraftConfigDeleteDropConfigResponse = (minecraftConfigDeleteDropConfigResponseSuccess | minecraftConfigDeleteDropConfigResponseError)

export const getMinecraftConfigDeleteDropConfigUrl = (dropConfigId: string,) => {




  return `/api/MinecraftConfig/${dropConfigId}`
}

export const useMinecraftConfigDeleteDropConfigHook = (): (dropConfigId: string, options?: RequestInit) => Promise<minecraftConfigDeleteDropConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (dropConfigId: string, options?: RequestInit) => {

        return customFetcher(getMinecraftConfigDeleteDropConfigUrl(dropConfigId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type minecraftConfigCreateDropConfigResponse200 = {
  data: ApiEnvelopeMinecraftConfigOperationResultDto
  status: 200
}

export type minecraftConfigCreateDropConfigResponse400 = {
  data: ApiEnvelopeMinecraftConfigOperationResultDto
  status: 400
}

export type minecraftConfigCreateDropConfigResponseSuccess = (minecraftConfigCreateDropConfigResponse200) & {
  headers: Headers;
};
export type minecraftConfigCreateDropConfigResponseError = (minecraftConfigCreateDropConfigResponse400) & {
  headers: Headers;
};

export type minecraftConfigCreateDropConfigResponse = (minecraftConfigCreateDropConfigResponseSuccess | minecraftConfigCreateDropConfigResponseError)

export const getMinecraftConfigCreateDropConfigUrl = () => {




  return `/api/MinecraftConfig`
}

export const useMinecraftConfigCreateDropConfigHook = (): (createMinecraftDropConfigRequest?: CreateMinecraftDropConfigRequest, options?: RequestInit) => Promise<minecraftConfigCreateDropConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (createMinecraftDropConfigRequest?: CreateMinecraftDropConfigRequest, options?: RequestInit) => {

        return customFetcher(getMinecraftConfigCreateDropConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMinecraftDropConfigRequest)
  }
);
      }
  }


export type minecraftConfigUpdateDropConfigResponse200 = {
  data: ApiEnvelopeMinecraftConfigOperationResultDto
  status: 200
}

export type minecraftConfigUpdateDropConfigResponse400 = {
  data: ApiEnvelopeMinecraftConfigOperationResultDto
  status: 400
}

export type minecraftConfigUpdateDropConfigResponseSuccess = (minecraftConfigUpdateDropConfigResponse200) & {
  headers: Headers;
};
export type minecraftConfigUpdateDropConfigResponseError = (minecraftConfigUpdateDropConfigResponse400) & {
  headers: Headers;
};

export type minecraftConfigUpdateDropConfigResponse = (minecraftConfigUpdateDropConfigResponseSuccess | minecraftConfigUpdateDropConfigResponseError)

export const getMinecraftConfigUpdateDropConfigUrl = () => {




  return `/api/MinecraftConfig`
}

export const useMinecraftConfigUpdateDropConfigHook = (): (updateMinecraftDropConfigRequest?: UpdateMinecraftDropConfigRequest, options?: RequestInit) => Promise<minecraftConfigUpdateDropConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (updateMinecraftDropConfigRequest?: UpdateMinecraftDropConfigRequest, options?: RequestInit) => {

        return customFetcher(getMinecraftConfigUpdateDropConfigUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMinecraftDropConfigRequest)
  }
);
      }
  }


